import { useSearchParams } from "react-router-dom";
import { OnboardingType } from "../types";
import { useAppSelector } from "../app/hooks";

const useRemoteParams = () => {
  const { onboardingType: savedTemplate } = useAppSelector(
    (state) => state.activeTemplate
  );
  const { draftUUID, formValues } = useAppSelector(
    (state) => state.onboardingData
  );
  const { token: savedToken } = useAppSelector((state) => state.authentication);
  const { cuil: renaperCuit } = useAppSelector((state) => state.renaper);

  const [searchParams] = useSearchParams();
  const remoteOnboardingType = searchParams.get("template") as OnboardingType;
  const remoteDraftUUID = searchParams.get("uuid");
  const remoteToken = searchParams.get("token");
  const continueWithQR = searchParams.get("withQR") === "true";
  const remoteCuit = searchParams.get("cuit");
  const remoteEmail = decodeURIComponent(
    searchParams.get("email") || ""
  ).replace(/ /g, "+");

  const token = savedToken || remoteToken || "";
  const onboardingType = savedTemplate || remoteOnboardingType || "";
  const uuid = draftUUID || remoteDraftUUID || "";
  const cuit = formValues?.["cuit"] || renaperCuit || remoteCuit || "";
  const email = formValues?.["email"] || remoteEmail || "";

  const remoteUrlParams = new URLSearchParams({
    uuid: uuid,
    token: token,
    template: onboardingType,
    cuit: cuit,
    email: email,
  });

  return {
    remoteUrlParams,
    values: {
      onboardingType,
      uuid,
      token,
      continueWithQR,
      cuit,
      email,
    },
  };
};

export default useRemoteParams;
